import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface AlertState {
  isOpen: boolean;
  type: "loading" | "success" | "error" | "warning" | "develop" | "verify" | "method-selection" | "verify-with-zalo";
  title?: string;
  text?: string;
  content?: string;
  showConfirmButton?: boolean;
  showCancelButton?: boolean;
  confirmButtonText?: string;
  cancelButtonText?: string;
  onConfirm?: Function;
  onCancel?: Function;
}

const initialState: AlertState = {
  isOpen: false,
  type: "loading",
  title: "",
  text: "",
  content: "",
};

const alertSlice = createSlice({
  name: "alert",
  initialState: initialState,
  reducers: {
    openAlert: (state, action: PayloadAction<Omit<AlertState, "isOpen">>) => {
      return {
        ...action.payload,
        isOpen: true,
      };
    },
    toggleAlert: (state, action: PayloadAction<Omit<AlertState, "isOpen">>) => {
      let newState = { ...state };
      if (newState.isOpen) {
        newState = initialState;
      } else {
        newState.type = action.payload.type;
        newState.title = action.payload.title;
        newState.content = action.payload.content;
      }
      return {
        ...newState,
        isOpen: !state.isOpen,
      };
    },
    closeAlert: () => {
      return initialState;
    },
  },
});

export const { openAlert, closeAlert, toggleAlert } = alertSlice.actions;

export default alertSlice.reducer;
